import _ from 'lodash';
import { isMaliciousCode } from '@skyjs/code-inspection';
import { DateTimeRange, UTCDateRange } from '@skyjs/date';

export default function isDateRangeExpressionValueValid(typeName, value) {
  return !isMaliciousCode(value).isMalicious && isValidValue(typeName, value);
}

function isValidValue(typeName, value) {
  const props = getAllProperties(typeName);

  return _.some(props, prop =>
    prop[0].toUpperCase() === prop[0]
      ? value === `${typeName}.${prop}`
      : value.startsWith(`${typeName}.${prop}(`) && value.indexOf(')') === value.length - 1
  );
}

function getAllProperties(typeName) {
  const properties = new Set();

  if (typeName === 'DateTimeRange') {
    Object.getOwnPropertyNames(DateTimeRange).forEach(prop => properties.add(prop));
  }

  Object.getOwnPropertyNames(UTCDateRange).forEach(prop => properties.add(prop));

  return [...properties].filter(
    prop => !['name', 'length', 'prototype'].includes(prop) && !prop.startsWith('_')
  );
}
